import {ISortButtonParams} from "./index";
import buttonHtml from './button.html?raw';

export let template: string = buttonHtml;

export class viewModel {

    constructor(private params: ISortButtonParams) {
    }

    getSortButtonAttr() {
        if (this.params.sortcol() == this.params.key) {
            if (this.params.asc()) {
                return {
                    css: "fa-sort-up fad fa-rw",
                    title: "sorted ascending"
                }
            } else {
                return {
                    css: "fa-sort-down fad fa-rw",
                    title: "sorted descending"
                }
            }
        }
        return {
            css: "fa-sort fal fa-rw",
            title: "not sorted"
        };
    }

    onSortClick = (): void => {
        const isAlreadySorted = this.params.sortcol() == this.params.key;
        this.params?.sortcol(this.params.key as any);
        this.params?.asc(isAlreadySorted ? !this.params.asc() : true);
        this.params?.onSortClick?.(this.params.key)
    };

}
